import { render, staticRenderFns } from "./MSTalkMessageText.vue?vue&type=template&id=4b5f5578&"
import script from "./MSTalkMessageText.vue?vue&type=script&lang=js&"
export * from "./MSTalkMessageText.vue?vue&type=script&lang=js&"
import style0 from "./MSTalkMessageText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports